import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Parallax = () => {
    gsap.registerPlugin(ScrollTrigger);
		const itemsFront = document.querySelectorAll("[data-parallax-front]");
		const itemsParallax = document.querySelectorAll("[data-parallax]");
		// 背景または画像のパララックス処理
		for (const item of itemsParallax) {
			const y = item.getAttribute("data-y") ?? "10%";
			const scale = item.getAttribute("data-scale") ?? "1.1";
			const delay = parseFloat(item.getAttribute("data-delay")) || 1.5;
			const img = item.querySelector("img");
			if (!img) continue; // imgがなければスキップ
			gsap.set(item, { overflow: "hidden" });
			gsap.set(img, { scale });

			gsap.fromTo(
			img,
			{ y: `-${y}` },
			{
				y,
				scrollTrigger: {
				trigger: item,
				start: "top bottom",
				end: "bottom top",
				scrub: delay,
				// markers: true,
				},
				ease: "none",
			}
			);
		}
		// 前面要素のパララックス処理
		for (const item of itemsFront) {
			const y = item.getAttribute("data-y") ?? "25%";
			const delay = parseFloat(item.getAttribute("data-delay")) || 0.4;
			// const targets = item.children;
			gsap.fromTo(
			item,
			{ y },
			{
				y: `-${y}`,
				scrollTrigger: {
				trigger: item,
				start: "bottom bottom",
				// end: "bottom top",
				scrub: delay,
				// markers: true,
				},
				ease: "none",
			}
			);
		}

  // console.log('Timeline duration:', timeline.duration() + 's');
}

const init = () => {
  Parallax();
}

export default init;